module.exports = __webpack_public_path__ + "img/club_sandwich.7a83a25f.jpeg";